module.exports = __webpack_public_path__ + "static/img/serveone.ed83fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/serveone.jpg
// module id = BMTY
// module chunks = 0